// Pizza Excellente — brand assets, copy, and config.
export const BRAND = {
  name: "Pizza Excellente",
  tagline: "Crust above the rest",
  email: "sales@pizzaexcellente.com",
  mailto: "mailto:sales@pizzaexcellente.com",
  phone_label: "Launching soon",
};

export const ASSETS = {
  logo: "/pizza-excellente-logo.png",
  logo_light: "/pizza-excellente-logo.png",
  logo_header: "/logo-header.png",
  logo_header_light: "/logo-header-light.png",
  logo_original: "https://customer-assets.emergentagent.com/job_304e5314-98a1-43a1-8d90-4b1728467f15/artifacts/88koextk_Pizza-Excellente-Logo.jpg",
  storefront: "https://customer-assets.emergentagent.com/job_304e5314-98a1-43a1-8d90-4b1728467f15/artifacts/k0cmqkhd_Pizza-Excellente.jpg",
  menu_left: "https://customer-assets.emergentagent.com/job_304e5314-98a1-43a1-8d90-4b1728467f15/artifacts/0z1n19km_BI-FOLD%20MENU%20%281%29.png",
  menu_right: "https://customer-assets.emergentagent.com/job_304e5314-98a1-43a1-8d90-4b1728467f15/artifacts/541ud8xg_BI-FOLD%20MENU%20%282%29.png",
  kitchen_layout: "https://customer-assets.emergentagent.com/job_304e5314-98a1-43a1-8d90-4b1728467f15/artifacts/h069s9oh_Final_Layout.jpg",
  interior_render: "https://customer-assets.emergentagent.com/job_pizza-community-dev/artifacts/smf6xc22_3D-Layout.jpg",
  investment_table: "https://customer-assets.emergentagent.com/job_pizza-community-dev/artifacts/2ij23hfe_Investment.png",
  hero_pizza: "https://images.pexels.com/photos/19786235/pexels-photo-19786235.jpeg",
  pizza_prep: "https://images.pexels.com/photos/34413649/pexels-photo-34413649.jpeg",
  cafe_interior: "https://customer-assets.emergentagent.com/job_pizza-community-dev/artifacts/smf6xc22_3D-Layout.jpg",
  burrata: "https://images.unsplash.com/photo-1758157835961-5db4a033390b",
  tiramisu: "https://images.pexels.com/photos/35135510/pexels-photo-35135510.jpeg",
  // additional curated food images (Unsplash / Pexels)
  margherita: "https://images.unsplash.com/photo-1604068549290-dea0e4a305ca?w=1600&q=80",
  pasta: "https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=1600&q=80",
  garlic_bread: "https://images.unsplash.com/photo-1573821663912-6df460f9c684?w=1600&q=80",
  ingredients: "https://images.unsplash.com/photo-1542834369-f10ebf06d3e0?w=1600&q=80",
  greater_noida: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=1600&q=80",
};

export const NAV = [
  { label: "Home", href: "/" },
  { label: "Our Story", href: "/our-story" },
  { label: "Why Us", href: "/why-pizza-excellente" },
  { label: "Franchise", href: "/franchise-opportunity" },
  { label: "Investment", href: "/investment" },
  { label: "Menu & Locations", href: "/menu-locations" },
  { label: "Contact", href: "/contact" },
];

export const ENQUIRY_TYPES = [
  { value: "franchise", label: "Franchise Enquiry" },
  { value: "investor", label: "Investor / Strategic Partner" },
  { value: "landlord", label: "Landlord / Location Opportunity" },
  { value: "supplier", label: "Supplier / Vendor" },
  { value: "media", label: "Media / Partnership" },
  { value: "general", label: "General Enquiry" },
];

export const STATS = {
  fee: { value: "₹5L", label: "Franchise fee" },
  royalty: { value: "4%", label: "Royalty" },
  term: { value: "7 yrs", label: "Term" },
  investment: { value: "₹55L", label: "Est. investment" },
  footprint: { value: "~700", label: "Sq ft footprint" },
  mix: { value: "70/30", label: "Takeout / Dine-in" },
  seats: { value: "~20", label: "Dine-in seats" },
  ros: { value: "~20%", label: "Return on sales (Yr 5)" },
  roi: { value: "~30%", label: "Return on investment" },
  payback: { value: "~3.5 yrs", label: "Payback" },
  aov: { value: "₹330", label: "Avg. order value" },
  growth: { value: "15%", label: "Annual revenue growth" },
};

export const MENU = {
  starters: [
    { name: "Garlic Breadsticks", desc: "Sprinkled with cheese, oregano and signature marinara." },
    { name: "Bruschetta", desc: "Toasted bread, olive oil, fresh tomatoes, basil and garlic." },
    { name: "Burrata", desc: "Fresh creamy burrata, greens, cherry tomatoes, basil and olive oil." },
    { name: "Toasted Ravioli", desc: "Cheese-filled ravioli, fried crisp, signature marinara." },
    { name: "Chicken Tenders", desc: "Homestyle tenders with spicy honey-hot sauce." },
    { name: "French Fries", desc: "Crisp golden potato strips, soft inside." },
  ],
  pizzas: [
    { name: "Cheese", desc: "Mozzarella over our signature pizza sauce." },
    { name: "Three Cheese", desc: "Mozzarella with parmesan and cheddar or ricotta." },
    { name: "Margherita", desc: "Mozzarella and fresh basil over tomato sauce with parmesan." },
    { name: "Marinara", desc: "Mozzarella, chopped fresh garlic, oregano and extra virgin olive oil." },
    { name: "Chicken Tikka", desc: "Chicken tikka, mozzarella and red onion drizzled with creamy sauce." },
    { name: "Paneer Tikka", desc: "Marinated paneer, green pepper and onion with creamy sauce." },
  ],
  entrees: [
    { name: "Chicken Parmigiana", desc: "Italian-seasoned chicken cutlet, marinara, mozzarella, spaghetti." },
    { name: "Chicken Broccoli Alfredo", desc: "Chicken and broccoli in creamy alfredo, fettuccine, parmesan." },
    { name: "Eggplant Parmigiana", desc: "Eggplant cutlets, marinara, mozzarella, baked, spaghetti." },
  ],
  sandwiches: [
    { name: "Chicken Parmigiana", desc: "Italian-seasoned chicken cutlet, marinara, mozzarella on Italian bread." },
    { name: "Eggplant Parmigiana", desc: "Eggplant cutlets, marinara and mozzarella on Italian bread." },
  ],
  desserts: [
    { name: "Tiramisu", desc: "Sponge soaked in vanilla and espresso, mascarpone, cocoa dust." },
    { name: "Brownie · Gluten-free", desc: "Decadently rich gluten-free chocolate brownie." },
    { name: "Cookie · Chocolate Chunk", desc: "Brown-butter cookie laced with chocolate chunks." },
    { name: "Cookie · Ricotta", desc: "Delicate ricotta-cheese cookie, soft and subtle." },
  ],
  toppings_standard: ["Marinated Tomatoes", "Roasted Red Peppers", "Mushrooms", "Fresh Basil", "Onions", "Broccoli", "Paneer Tikka", "Provolone Cheese"],
  toppings_specialty: ["Chicken Pepperoni", "Chicken Sausage", "Chicken Tikka", "Pesto"],
};
